const GRID_SIZE = 8;

export function spacing(factor = 1) {
	return GRID_SIZE * factor;
}
